import { Services, joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, labelModes, permissionPresets, proxy, request } from '@/utils'

import render from './render'

export default {
  name: 'PaymentsMethodSelect',

  mixins: [ proxy() ],

  props: {
    OwnerId: String,

    items: {
      type: Array,
      default: undefined
    },

    labelMode: {
      type: String,
      default: labelModes.hidden,
      validator: value => {
        return Object.values(labelModes).includes(value)
      }
    },

    as: {
      type: String,
      default: 'select',
      validator: value => {
        return [ 'select', 'buttons' ].includes(value)
      }
    },

    dense: Boolean,
    clearable: Boolean,
    required: Boolean,
    disabled: Boolean
  },

  data() {
    return {
      methods: [],

      loading: false
    }
  },

  computed: {
    canGetPayments() {
      return this.checkPermissions(`advanced.${Services.payments}.get`, permissionPresets.meUp)
    },

    displayItems() {
      const items = this.items || this.methods || []

      return items.map(value => {
        return {
          title: this.getTranslate(`${Services.payments}.methods.${value}`),
          value
        }
      })
    },

    isDisabled() {
      if (this.disabled || this.loading) {
        return true
      }

      if (this.required && this.displayItems.length === 1) {
        return true
      }

      if (this.displayItems.length === 0) {
        return true
      }
    }
  },

  watch: {
    methods: {
      handler() {
        if (this.required) {
          if (this.methods.length) {
            if (!this.methods.includes(this.proxy)) {
              this.proxy = this.methods[0]
            }
          } else {
            this.proxy = undefined
          }
        }
      },
      deep: true
    }
  },

  async mounted() {
    if (Array.isArray(this.items)) {
      return
    }

    await this.getPaymentsMethods()
    if (this.required) {
      if (this.methods.length) {
        if (!this.proxy) {
          this.proxy = this.methods[0]
        }
      }
    }
  },

  methods: {
    async getPaymentsMethods() {
      try {
        this.loading = true
        if (this.canGetPayments) {
          const UserId = this.OwnerId || this.account.id
          if (UserId) {
            const response = await request.get(joinURLPath(Services.payments, 'methods'), undefined, { UserId })
            if (Array.isArray(response)) {
              this.methods = response
              this.$emit('methods', response)
            }
          }
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
